<template>
  <div class="experience-wrapper">
    <LadBreadcrumb
      :uuid="exExperience.uuid"
      :is-favorite="exExperience.favorite"
      @toggle="toggleFavorite"
    />

    <LadSlider />

    <div v-loading="loading">
      <el-container class="experience-wrapper--container-top">
        <el-main
          id="experience-wrapper--main-top"
          class="experience-wrapper--main"
        >
          <LadExperienceTabs
            cache-prefix="experience-tabs"
            :cache-key="cacheKey"
          />

          <LadMessageLocalFlex v-if="exExperience.isLad" />
        </el-main>
        <el-aside class="experience-wrapper--aside" style="width: 380px;">
          <LadReviewNavbar
            cache-prefix="experience-review"
            :cache-key="cacheKey"
          />

          <LadAffix
            relative-element-selector="#experience-wrapper--main-top"
            :offset="{ top: -80, bottom: 20 }"
            :enabled="!isMobile"
          >
            <LadSidebarMain
              cache-prefix="experience-sidebar"
              :cache-key="cacheKey"
            />
          </LadAffix>
        </el-aside>
      </el-container>

      <LadSectionMap v-if="exExperience.isLad && exExperience.starting_point" />

      <LadLandingAvailabilityCustom
        v-if="
          exExperience.isLad &&
          isMobile &&
          availabilityInitialized &&
          hasAvailability
        "
        cache-prefix="landing-whats-availability-custom"
        :cache-key="cacheKey"
        @is-visible="isVisibleHandle"
      />

      <template
        v-if="
          hasRecommendedAvailability &&
          (hasAvailability || withAvailability) &&
          !isExternalPlatform
        "
      >
        <LadAvailabilityCustomBanner />
      </template>

      <template
        v-if="
          hasRecommendedAvailability && (hasAvailability || withAvailability)
        "
      >
        <el-container
          v-if="hasRecommendedAvailability && !isMobile"
          class="experience-wrapper--container-availability"
        >
          <el-aside class="experience-wrapper--aside">
            <LadAffix
              relative-element-selector="#experience-wrapper--main-availability"
              :offset="{ top: 40, bottom: 20 }"
              :enabled="!isMobile"
            >
              <LadSidebarAvailability />
            </LadAffix>
          </el-aside>

          <el-main
            id="experience-wrapper--main-availability"
            v-loading="loadings.availability"
            class="experience-wrapper--main"
          >
            <LadSectionCheckAvailability />
          </el-main>
        </el-container>
      </template>

      <LazyHydrate
        v-if="tabs.includes('extras')"
        :when-visible="{ rootMargin: '100px' }"
      >
        <el-container class="experience-wrapper--container-extras">
          <el-aside class="experience-wrapper--aside">
            <LadAffix
              relative-element-selector="#experience-wrapper--main-extras"
              :offset="{ top: 40, bottom: 20 }"
              :enabled="!isMobile"
            >
              <LadSidebarExtras />
            </LadAffix>
          </el-aside>
          <el-main
            id="experience-wrapper--main-extras"
            class="experience-wrapper--main"
          >
            <LadTabExtras />
          </el-main>
        </el-container>
      </LazyHydrate>

      <el-container
        v-if="tabs.includes('for-me')"
        class="experience-wrapper--container-for-me"
      >
        <el-aside class="experience-wrapper--aside">
          <LadAffix
            relative-element-selector="#experience-wrapper--main-for-me"
            :offset="{ top: 40, bottom: 20 }"
            :enabled="!isMobile"
          >
            <LadSidebarForMe />
          </LadAffix>
        </el-aside>
        <el-main
          id="experience-wrapper--main-for-me"
          class="experience-wrapper--main"
        >
          <LadTabForMe />
        </el-main>
      </el-container>

      <LazyHydrate
        v-if="exReviews.count"
        :when-visible="{ rootMargin: '200px' }"
      >
        <LadReviewsExperience
          id="experience-wrapper--main-reviews"
          class="wrapper--main-reviews"
        />
      </LazyHydrate>

      <LazyHydrate
        v-if="tabs.includes('faqs')"
        :when-visible="{ rootMargin: '100px' }"
      >
        <el-container class="experience-wrapper--container-faqs">
          <el-aside class="experience-wrapper--aside">
            <LadAffix
              relative-element-selector="#experience-wrapper--main-faqs"
              :offset="{ top: 40, bottom: 20 }"
              :enabled="!isMobile"
            >
              <LadSidebarFaqs />
            </LadAffix>
          </el-aside>
          <el-main
            id="experience-wrapper--main-faqs"
            class="experience-wrapper--main"
          >
            <LadTabFaqs />
          </el-main>
        </el-container>
      </LazyHydrate>

      <template v-if="enableVisa">
        <el-container class="experience-wrapper--container-visa">
          <el-aside class="experience-wrapper--aside">
            <LadAffix
              relative-element-selector="#experience-wrapper--main-visa"
              :offset="{ top: 40, bottom: 20 }"
              :enabled="!isMobile"
            >
              <LadSidebarVisa />
            </LadAffix>
          </el-aside>
          <el-main
            id="experience-wrapper--main-visa"
            class="experience-wrapper--main"
          >
            <LadTabVisa />
          </el-main>
        </el-container>
      </template>
      <template v-if="isProductChatProvider">
        <el-container
          id="lad-landing--form"
          class="experience-wrapper--container-contact-us"
        >
          <el-aside class="experience-wrapper--aside">
            <LadSidebarContactUs />
          </el-aside>

          <el-main>
            <LadAskQuestionModal />
          </el-main>
        </el-container>
      </template>
      <LazyHydrate v-else :when-visible="{ rootMargin: '100px' }">
        <el-container
          id="lad-landing--form"
          class="experience-wrapper--container-contact-us"
        >
          <el-aside class="experience-wrapper--aside">
            <LadSidebarContactUs />
          </el-aside>

          <el-main>
            <LazyLoading
              :key="`contact`"
              :loaded="lazy.contact"
              :loading="lazy.contact === false"
              @loaded="(e) => (lazy.contact = e)"
            >
              <LadZohoFormLead v-if="lazy.contact" @submitted="handleSubmitted">
                <LadFacebookWidget
                  v-if="submitted"
                  slot="sent"
                  :group-id="exExperience.facebook_group_id"
                />
              </LadZohoFormLead>

              <template slot="css-skeleton" />
            </LazyLoading>
          </el-main>
        </el-container>
      </LazyHydrate>

      <LazyHydrate :when-visible="{ rootMargin: '100px' }">
        <el-container
          id="lad-landing--form"
          class="experience-wrapper--container-provider"
        >
          <el-aside class="experience-wrapper--aside">
            <LadSidebarProvider />
          </el-aside>

          <el-main>
            <LazyLoading
              :key="`provider`"
              :loaded="lazy.provider"
              :loading="lazy.provider === false"
              @loaded="(e) => (lazy.provider = e)"
            >
              <LadSectionProvider />

              <template slot="css-skeleton" />
            </LazyLoading>
          </el-main>
        </el-container>
      </LazyHydrate>

      <template v-if="!isMobile && (hasAvailability || withAvailability)">
        <LazyHydrate never :trigger-hydration="isAvailabilityModalOpen">
          <LadAvailabilityModal
            v-if="isAvailabilityModalOpen"
            :experience="experience"
          />
        </LazyHydrate>
      </template>

      <LadConfidence cache-prefix="lad-confidence" :cache-key="cacheKey" />

      <!-- <LadGotoMoreInformation :only-mobile="true" /> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { hydrateNever, hydrateWhenVisible } from 'vue-lazy-hydration'
import AnalyticsExperienceMixin from '@/utils/mixin/analytics-experience'
import LadExperienceTabs from '@/components/pages/experience/tabs'
import ExperienceMetaMixin from '@/utils/mixin/product-meta'

export default {
  name: 'LadExperience',
  components: {
    LadSectionProvider: hydrateNever(() =>
      import(
        /* webpackChunkName: "lad-section-provider" */ '@/components/provider/section'
      )
    ),
    LadSidebarProvider: hydrateNever(() =>
      import(
        /* webpackChunkName: "lad-experience-sidebar-provider" */ '@/components/pages/experience/sidebar/provider'
      )
    ),
    LadMessageLocalFlex: () =>
      import(
        /* webpackChunkName: "lad-message-local-flex" */ '@/components/pages/experience/partials/message-localflex'
      ),
    LadSlider: () =>
      import(
        /* webpackChunkName: "lad-experience-slider" */ '@/components/pages/experience/partials/slider'
      ),
    LadReviewNavbar: () =>
      import(
        /* webpackChunkName: "lad-experience-navbar-review" */ '@/components/navbars/experience-review'
      ),
    LadBreadcrumb: () =>
      import(
        /* webpackChunkName: "lad-breadcrumb" */ '@/components/breadcrumb/index'
      ),
    LadExperienceTabs,
    LadSidebarMain: () =>
      import(
        /* webpackChunkName: "lad-experience-sidebar" */ '@/components/pages/experience/sidebar/main'
      ),
    LadSidebarContactUs: () =>
      import(
        /* webpackChunkName: "lad-experience-sidebar-contact-us" */ '@/components/pages/experience/sidebar/contact-us'
      ),
    LadSidebarAvailability: () =>
      import(
        /* webpackChunkName: "lad-experience-sidebar-availability" */ '@/components/pages/experience/sidebar/availability'
      ),
    LadSectionMap: () =>
      import(
        /* webpackChunkName: "lad-experience-map" */ '@/components/pages/experience/partials/map'
      ),
    LadReviewsExperience: () =>
      import(
        /* webpackChunkName: "lad-reviews" */ '@/components/lad-reviews/experience'
      ),
    LadFacebookWidget: () =>
      import(
        /* webpackChunkName: "lad-face-widget" */ '@/components/facebook/widget'
      ),
    LadZohoFormLead: () =>
      import(
        /* webpackChunkName: "lad-zoho-form--lead" */ '@/components/zoho-form/lead'
      ),
    LadSectionCheckAvailability: () =>
      import(
        /* webpackChunkName: "lad-check-availability" */ '@/components/pages/experience/partials/check-availability'
      ),
    LadAvailabilityModal: () =>
      import(
        /* webpackChunkName: "lad-ava-modal" */ '@/components/frontends/Availability/modal'
      ),
    LadAvailabilityCustomBanner: () =>
      import(
        /* webpackChunkName: "lad-ava-banner" */ '@/components/pages/experience/partials/availability-custom/banner'
      ),
    LadConfidence: () =>
      import(
        /* webpackChunkName: "lad-confidence" */ '@/components/confidence'
      ),
    LadAskQuestionModal: () =>
      import(
        /* webpackChunkName: "lad-ava-modal" */ '@/components/pages/experience/partials/ask-question/modal'
      ),

    LadTabForMe: hydrateNever(() =>
      import(
        /* webpackChunkName: "lad-tab-for-me" */ '@/components/pages/experience/tabs/components/for-me'
      )
    ),
    LadSidebarForMe: hydrateNever(() =>
      import(
        /* webpackChunkName: "lad-experience-sidebar-for-me" */ '@/components/pages/experience/sidebar/for-me'
      )
    ),

    LadTabFaqs: hydrateWhenVisible(() =>
      import(
        /* webpackChunkName: "lad-tab-faq" */ '@/components/pages/experience/tabs/components/faq'
      )
    ),
    LadSidebarFaqs: hydrateNever(() =>
      import(
        /* webpackChunkName: "lad-experience-sidebar-faqs" */ '@/components/pages/experience/sidebar/faqs'
      )
    ),

    LadTabVisa: hydrateWhenVisible(() =>
      import(
        /* webpackChunkName: "lad-tab-visa" */ '@/components/pages/experience/tabs/components/visa'
      )
    ),
    LadSidebarVisa: hydrateNever(() =>
      import(
        /* webpackChunkName: "lad-experience-sidebar-visa" */ '@/components/pages/experience/sidebar/visa'
      )
    ),

    LadTabExtras: hydrateWhenVisible(() =>
      import(
        /* webpackChunkName: "lad-tab-extra" */ '@/components/pages/experience/tabs/components/extras/index'
      )
    ),
    LadSidebarExtras: hydrateNever(() =>
      import(
        /* webpackChunkName: "lad-experience-sidebar-extras" */ '@/components/pages/experience/sidebar/extras'
      )
    ),

    // LadGotoMoreInformation: () =>
    //   import(
    //     /* webpackChunkName: "lad-goto-more-information" */ '@/components/pages/experience/partials/goto-more-information'
    //   ),

    LadLandingAvailabilityCustom: () =>
      import(
        /* webpackChunkName: "lad-landing-availability-custom" */ '@/components/pages/landing/partials/custom/availability/index'
      ),
  },
  mixins: [AnalyticsExperienceMixin],
  async asyncData({ app, store, route, params, redirect }) {
    let loading = !!process.server

    const response = await store.dispatch('experience/getData', {
      permalink: params.permalink,
    })

    if (response === 'success') {
      await store.dispatch(
        'availability/hasAvailability',
        store.state.experience.experience.availability.dates
      )

      await store.dispatch(
        'availability/hasRecommendedAvailability',
        store.state.experience.experience.availability.recommended
      )

      const items = store.state.experience.breadcrumbs
      if (Object.keys(items).length > 0) {
        const breadcrumb = []
        const keys = ['continent', 'country', 'city']

        keys.forEach((key) => {
          if (items[key]) {
            const to = {
              name: key === 'country' ? 'search-country' : 'search-type',
              params: {
                type: app.i18n.t(`router.search_type.type.${key}`),
                value: items[key].slug,
                tab:
                  key === 'country'
                    ? null
                    : app.i18n.t('router.search_type.tab.tours'),
                travelTo: app.i18n.t('router.search_type.travel_to_'),
              },
            }

            breadcrumb.push({ to, text: items[key].name })
          }
        })

        breadcrumb.push({
          to: null,
          text: store.state.experience.experience.name,
        })

        await store.dispatch('app/setBreadcrumb', breadcrumb)
      }
    } else {
      const {
        status,
        data: { data },
      } = response || { status: 404, data: {} }

      if (status === 301) {
        redirect(status, route.fullPath.replace(params.permalink, data))
      } else {
        redirect('/404')
      }
    }

    loading = false

    return { loading }
  },
  data() {
    return {
      loading: true,
      submitted: false,
      lazy: {
        sidebar: false,
        contact: false,
        availability: false,
        provider: false,
      },
      cover: { sources: [], medias: [], src: null, srcset: null },
      loadings: {
        availability: true,
      },
      availabilityInitialized: false,
    }
  },
  computed: {
    ...mapState('app', ['breadcrumb', 'country']),
    ...mapState('experience', {
      promotions: 'promotions',
      exExperience: (state) => ({
        uuid: state.experience.uuid,
        isLad: state.experience.is_lad,
        name: state.experience.name,
        permalink: state.experience.permalink.default,
        keywords: state.experience.keywords,
        headline: state.experience.headline,
        facebook_group_id: state.experience.facebook_group_id,
        starting_point: state.experience.starting_point,
        country: state.experience.country,
        // se usa en los meta
        ending_point: state.experience.ending_point,
        duration: state.experience.duration,
        starting_point_country: state.experience.starting_point_country,
        ending_point_country: state.experience.ending_point_country,
        favorite: state.experience.favorite,
      }),
      exPlatform: (state) => state.platform,
      isExternalPlatform: (state) => !state.experience.is_lad,
      totalAmount: (state) => state.sales_plan.total_amount,
      layawayAmount: (state) => state.sales_plan.layaway_amount,
      continent: (state) =>
        Object.keys(state.breadcrumbs).length
          ? state.breadcrumbs.continent.name
          : null,
      exCover: 'cover',
      exGallery: 'gallery',
      exReviews: 'reviews',
      exFaqs: 'faqs',
      tabs: (state) => {
        /** revisar `components/pages/experience/tabs/index.vue` si hay cambios aqui */
        const tabs = []
        const items = [].concat(
          state.extras.map((t) => t.uuid),
          state.rooms.map((t) => t.uuid),
          state.insurances.map((t) => t.uuid),
          state.flights.map((t) => t.uuid)
        )

        if (state.whats_included.length) tabs.push('whats-included')

        tabs.push('overview')

        if (items.length > 0) tabs.push('extras')
        if (state.for_me.length) tabs.push('for-me')
        if (state.faqs.length) tabs.push('faqs')

        return tabs
      },
    }),
    ...mapState('availability', {
      hasAvailability: (state) => state.exist,
      withAvailability: (state) => state.availability.ranges.length > 0,
      hasRecommendedAvailability: (state) => state.hasRecommendedAvailability,
    }),
    ...mapState('settings', ['currency']),
    ...mapGetters('settings', ['language']),
    ...mapGetters('device', ['isMobile']),
    ...mapState('modals', {
      isAvailabilityModalOpen: (state) => state.availability.opened,
      isAskQuestionModalOpen: (state) => state.askQuestion.opened,
    }),
    experience() {
      return {
        name: this.exExperience.name,
        starting_point: this.exExperience.starting_point,
      }
    },
    cacheKey() {
      return `${this.exExperience.uuid}--${this.language}-${this.currency}--${
        this.isMobile ? 'm' : 'd'
      }`
    },
    enableVisa() {
      return this.exExperience.country.alpha_3_code !== this.country
    },
    isProductChatProvider() {
      return process.env.PRODUCTS_CHAT_PROVIDER.includes(this.exExperience.uuid)
    },
  },
  watch: {
    'exExperience.uuid': {
      immediate: true,
      async handler(uuid, oldValue) {
        if (process.server) return false

        if (uuid) {
          if (typeof oldValue === 'undefined') {
            this.loadAvailability()
          }

          await this.$store.dispatch(
            'app/updateWrapper',
            `wrapper--experience-${uuid}`
          )

          this.sendAnalytics()

          this.$store.dispatch('messenger/UpdateFloatingParent', { uuid })
        }
      },
    },
  },
  created() {
    this.$nuxt.$on('set-preload', (response) => {
      this.cover = response
    })
  },
  async beforeDestroy() {
    this.$nuxt.$off('set-preload')

    /** no quitar condicion, no carga cuando hace busqueda de una experiencia en top navbar */
    if (
      ![
        'checkout-layaway',
        'landing-permalink-test',
        'h-permalink',
        'f-permalink',
        'product-permalink',
        'product-permalink-ppcv1',
      ].includes(this.$route.name)
    ) {
      await this.$store.dispatch('availability/setDefault')
      await this.$store.dispatch('experience/setDefault')
    }
  },
  methods: {
    handleSubmitted() {
      this.submitted = true
      if (process.browser && typeof this.$gtag !== 'undefined') {
        let price = this.totalAmount
        if (this.promotions.length > 0) {
          const isCurrentPromotion =
            Date.parse(this.promotions[0].end) >= Date.now()

          if (this.promotions[0].rules.length > 0) {
            price = this.promotions[0].rules[0].condition.includes(
              this.currency
            )
              ? this.totalAmount * (1 - this.promotions[0].value / 100)
              : this.totalAmount
          } else if (isCurrentPromotion) {
            price = this.totalAmount * (1 - this.promotions[0].value / 100)
          }
        }
        this.$gtag('event', 'generate_lead_question', {
          event_label: this.exExperience.name,
          value: price.toFixed(2).toString(),
          currency: this.currency,
          page_title: this.$metaInfo.title,
          page_location: window.location.href,
        })
      }
    },
    async loadAvailability() {
      this.loadings.availability = true
      await this.$store.dispatch('availability/getData', {
        experience: this.$route.params.permalink,
        withRestriction: true,
        withCodes: this.exPlatform.name === 'LocalAdventures',
      })
      this.loadings.availability = false
      this.availabilityInitialized = true
    },
    async toggleFavorite() {
      await this.$store.dispatch('experience/toggleFavorite')
    },
    isVisibleHandle(visible) {
      if (process.client) {
        const drawer = document.querySelector('.lad-bottom-drawer-availability')
        if (drawer) {
          drawer.style.setProperty(
            'display',
            visible ? 'none' : 'block',
            'important'
          )
        }
      }
    },
  },
  head() {
    /** NOTA: No se puede utilizar mixin tradicional porque sobreescribe la function `head` */
    const meta = ExperienceMetaMixin.head.call(this)

    const preloads = []
    this.cover.sources.forEach((source, i) => {
      preloads.push({
        rel: 'preload',
        as: 'image',
        fetchpriority: 'high',
        imagesrcset: source,
        media: this.cover.medias[i].media,
      })
    })

    meta.link = [].concat(meta.link, preloads)

    return {
      ...meta,
      script: meta.script,
    }
  },
  validate({ params }) {
    return typeof params.test === 'undefined'
  },
}
</script>

<style lang="scss">
.experience-wrapper {
  &--aside {
    .affix {
      overflow: auto;
    }
  }

  .app--container-breadcrumb {
    background-color: transparent;
    // padding: 0 0 20px;

    // .app--breadcrumb {
    //   padding-top: 0;
    // }
  }

  @media screen and (max-width: 1026px) {
    &--container-availability,
    &--container-question,
    &--container-contact-us,
    &--container-extras,
    &--container-for-me,
    &--container-faqs,
    &--container-visa,
    &--container-provider {
      .el-aside {
        padding-left: 20px;
        padding-right: 20px;
      }
      .el-main {
        margin-top: 20px;
      }
    }
  }

  @media screen and (max-width: 700px) {
    &--container-availability,
    &--container-question,
    &--container-contact-us,
    &--container-extras,
    &--container-for-me,
    &--container-faqs,
    &--container-visa,
    &--container-provider {
      .el-main {
        padding-top: 0;
        padding-left: 0;
        padding-right: 0;
      }
    }
  }
}
</style>
